// Line icons (24×24, stroke via CSS) — same paths as the concept.
const ICONS = {
  home: '<rect x="3.5" y="3.5" width="7" height="9" rx="2.5"/><rect x="13.5" y="3.5" width="7" height="5" rx="2.5"/><rect x="13.5" y="11.5" width="7" height="9" rx="2.5"/><rect x="3.5" y="15.5" width="7" height="5" rx="2.5"/>',
  news: '<rect x="4" y="4.5" width="16" height="15" rx="3"/><path d="M8 9h8M8 12.5h8M8 16h5"/>',
  cal: '<rect x="3.5" y="5" width="17" height="15.5" rx="3.5"/><path d="M8 3v4M16 3v4M3.5 10h17"/>',
  ws: '<path d="M3.5 20.5h17M5.5 17V10M10 17v-7M14 17v-7M18.5 17v-7M3.5 8 12 3.5 20.5 8z"/>',
  pie: '<path d="M12 3.5a8.5 8.5 0 1 0 8.5 8.5H12z"/><path d="M15 3.9A8.5 8.5 0 0 1 20.1 9H15z"/>',
  link: '<circle cx="5" cy="6" r="2"/><circle cx="19" cy="6" r="2"/><circle cx="12" cy="18" r="2"/><path d="M7 6h10M6 8l5 8.3M18 8l-5 8.3"/>',
  radar: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><path d="M12 12 18 6"/>',
  ai: '<path d="M12 3.5c.6 4.3 2.2 5.9 6.5 6.5-4.3.6-5.9 2.2-6.5 6.5-.6-4.3-2.2-5.9-6.5-6.5 4.3-.6 5.9-2.2 6.5-6.5z"/><path d="M18.5 15.5c.3 1.9 1 2.6 2.9 2.9-1.9.3-2.6 1-2.9 2.9-.3-1.9-1-2.6-2.9-2.9 1.9-.3 2.6-1 2.9-2.9z"/>',
  gear: '<path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/>',
  whale: '<path d="M3 13c2.5 0 3.5-3 7-3 4 0 5.5 3 8.5 3 1.2 0 2-.6 2.5-1.5-.2 3.8-3.6 6.5-8.5 6.5S4.5 15.8 3 13z"/><path d="M18 9.5c.8-1.6 2.2-2.3 3-2.5-.3 1-.4 2 0 3"/>',
  x: '<path d="M5 5l14 14M19 5 5 19"/>',
  price: '<path d="M4 16l5-5 4 4 7-7"/><path d="M15 8h5v5"/>',
  yt: '<rect x="3.5" y="6" width="17" height="12" rx="4"/><path d="m10.5 9.5 4 2.5-4 2.5z"/>',
  macro: '<path d="M4 19.5h16M6.5 16V11M11 16V7M15.5 16v-6M20 16V5"/>',
  arrow: '<path d="M7 17 17 7M9 7h8v8"/>',
  play: '<path d="m9 7 8 5-8 5z"/>',
  bell: '<path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15z"/><path d="M10 20.5a2 2 0 0 0 4 0"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  chev: '<path d="m9 6 6 6-6 6"/>',
  chevl: '<path d="m15 6-6 6 6 6"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4"/>',
  moon: '<path d="M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10z"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  sidebar: '<rect x="3.5" y="4.5" width="17" height="15" rx="3.5"/><path d="M9.5 4.5v15"/>',
  search: '<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/>',
  check: '<circle cx="12" cy="12" r="8.5"/><path d="m8.5 12.2 2.4 2.4 4.6-4.9"/>',
  alert: '<path d="M12 4.2 2.8 19.5h18.4z"/><path d="M12 10v4.2M12 16.9v.1"/>',
  copy: '<rect x="8.5" y="8.5" width="11" height="11" rx="2.5"/><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"/>',
  like: '<path d="M7.5 10.5v9h-3v-9zM7.5 10.5l3.6-6.3a1.8 1.8 0 0 1 3.3 1.3l-.9 3.7h5.3a2 2 0 0 1 2 2.4l-1.3 6a2 2 0 0 1-2 1.4H7.5"/>',
  refresh: '<path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3"/><path d="M19.5 4.5v4h-4"/>',
  menu: '<path d="M5 8h14M5 12h14M5 16h9"/>',
  send: '<path d="M12 19V5M6 11l6-6 6 6"/>',
  mail: '<rect x="3.5" y="5.5" width="17" height="13" rx="3"/><path d="m4.5 7.5 7.5 5.5 7.5-5.5"/>',
  lock: '<rect x="5" y="10.5" width="14" height="9.5" rx="3"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5M12 14.5v2"/>',
  tg: '<path d="M20.5 4.5 3.5 11.2l5.6 2 2 6.3 3.1-3.9 4.6 3.4z"/><path d="m9.1 13.2 8.4-6.2"/>',
  laptop: '<rect x="5" y="5.5" width="14" height="9.5" rx="2"/><path d="M3 18.5h18"/>',
  phone: '<rect x="7" y="3.5" width="10" height="17" rx="2.5"/><path d="M11 17.5h2"/>',
  shield: '<path d="M12 3.5 5 6v5.5c0 4.2 3 7.6 7 9 4-1.4 7-4.8 7-9V6z"/><path d="m9 12 2.2 2.2L15.5 10"/>',
  globe: '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.4 2.5 3.5 5.3 3.5 8.5s-1.1 6-3.5 8.5c-2.4-2.5-3.5-5.3-3.5-8.5s1.1-6 3.5-8.5z"/>',
  card: '<rect x="3.5" y="6" width="17" height="12" rx="3"/><path d="M3.5 10h17M7 14.5h3"/>',
  logout: '<path d="M14 4.5H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7M10.5 12h10M17 8.5l3.5 3.5-3.5 3.5"/>',
  trash: '<path d="M4.5 7h15M9.5 7V5h5v2M6.5 7l1 12.5h9l1-12.5"/>',
  eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  eyeoff: '<path d="M4 4l16 16M10 6c.6-.3 1.3-.5 2-.5 6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.7 3.4M6.6 7.6A16 16 0 0 0 2.5 12S6 18.5 12 18.5c1.5 0 2.8-.4 4-1"/>',
  user: '<circle cx="12" cy="8.5" r="4"/><path d="M4.5 20c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5"/>',
} as const;

export type IconName = keyof typeof ICONS;

export function Icon({ name, className }: { name: IconName | string; className?: string }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={className} dangerouslySetInnerHTML={{ __html: ICONS[name as IconName] ?? '' }} />;
}

/** Outlined circle with an icon (`.ic`), optional ember badge. */
export function IconCircle({ name, badge = false }: { name: IconName | string; badge?: boolean }) {
  return <span className="ic"><Icon name={name} />{badge && <em />}</span>;
}

/** The two-state glyph used by the expanding-circle buttons (› then →). */
export function ChevArrow() {
  return (
    <>
      <svg className="xb-chev" viewBox="0 0 24 24"><path d="m10 7 5 5-5 5" /></svg>
      <svg className="xb-arr" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
    </>
  );
}
